<template>
  <svg 
    fill="none" 
    height="40" 
    viewBox="0 0 44 44" 
    width="40" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.74375 34.0368C8.80198 36.6512 11.4962 38.6942 14.5691 39.9706C17.642 41.247 20.9908 41.7141 24.2957 41.3272L23.0857 30.9891C21.5486 31.169 19.991 30.9517 18.5618 30.3581C17.1326 29.7644 15.8795 28.8142 14.9222 27.5983L6.74375 34.0368Z"
      fill="#0A38C9"
    />
    <path
      d="M28.7461 3.59555C26.0315 2.59878 23.1301 2.21485 20.2497 2.47128C17.3693 2.72771 14.5814 3.61815 12.0856 5.07877L17.4153 14.1856C18.5678 13.5111 19.8553 13.0999 21.1854 12.9815C22.5156 12.8631 23.8554 13.0404 25.109 13.5007L28.7461 3.59555Z"
      fill="#194BFB"
    />
    <path
      d="M38.8606 7.86781C36.3799 4.90815 33.1638 2.65363 29.5356 1.33084L25.0993 13.499C26.5916 14.0431 27.9143 14.9703 28.9346 16.1876L38.8606 7.86781Z"
      fill="#F1104E"
    />
    <path
      d="M38.8858 31.7295C40.8821 28.2718 41.7665 24.2837 41.419 20.3062C41.0715 16.3288 39.509 12.5544 36.9433 9.4953L28.9746 16.1785C30.169 17.6027 30.8964 19.3598 31.0582 21.2114C31.22 23.0631 30.8083 24.9197 29.8789 26.5294L38.8858 31.7295Z"
      fill="#0A38C9"
    />
    <path
      d="M0.749632 16.306C-0.142095 19.6339 -0.239723 23.1248 0.46461 26.4974C1.16894 29.87 2.65555 33.0301 4.80467 35.723L14.9229 27.648C14.0384 26.5397 13.4265 25.2391 13.1366 23.851C12.8467 22.463 12.8869 21.0262 13.2539 19.6565L0.749632 16.306Z"
      fill="#194BFB"
    />
    <path
      d="M23.9539 43.9131C29.1369 43.4509 33.9883 41.1666 37.6464 37.4658C41.3044 33.765 43.5323 28.8874 43.9343 23.6994L31.0175 22.6986C30.8523 24.8315 29.9364 26.8368 28.4325 28.3582C26.9286 29.8797 24.9341 30.8188 22.8033 31.0088L23.9539 43.9131Z"
      fill="#194BFB"
    />
    <path
      d="M13.1079 6.57694C11.0824 7.74633 9.30716 9.30321 7.8834 11.1587C6.45965 13.0142 5.41529 15.1319 4.80997 17.391L14.0688 19.8719C14.3483 18.8287 14.8305 17.8507 15.488 16.9939C16.1455 16.1371 16.9653 15.4181 17.9006 14.8781L13.1079 6.57694Z"
      fill="#0A38C9"
    />
    <path
      d="M22.0477 12.9342C17.0409 12.9342 12.982 16.993 12.982 21.9998C12.982 27.0066 17.0409 31.0654 22.0477 31.0654C27.0545 31.0654 31.1133 27.0066 31.1133 21.9998C31.1133 16.993 27.0545 12.9342 22.0477 12.9342ZM22.0477 26.5326C19.5443 26.5326 17.5149 24.5032 17.5149 21.9998C17.5149 19.4964 19.5443 17.467 22.0477 17.467C24.5511 17.467 26.5805 19.4964 26.5805 21.9998C26.5805 24.5032 24.5511 26.5326 22.0477 26.5326Z"
      fill="white"
    />
    <ellipse 
      cx="5.53741" 
      cy="5.53742" 
      fill="#091540" 
      rx="5.53741" 
      ry="5.53742" 
      transform="matrix(-1 0 0 1 27.5469 16.4624)" 
    />
    <ellipse 
      cx="1.6168" 
      cy="1.67454" 
      fill="white" 
      rx="1.6168" 
      ry="1.67454" 
      transform="matrix(-1 0 0 1 25.75 18.5923)" 
    />
  </svg>
</template>

<script>
export default {
  name: 'NlpLogoMobile',
}
</script>